// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, type FormProps } from 'redux-form';
import { injectIntl, type IntlShape } from 'react-intl';

import type { Dispatch } from 'state/types';
import DialogPanel from 'view/App/DialogPanels/DialogPanel';
import { hideDialogPanel } from 'state/commands/dialogPanelCommands';
import localizedStrings from 'util/localizedStrings';
import {
  CREATE_MEDIA_ENGINE_PANEL_ID,
  MEDIA_ENGINE_DEFAULT_PORT,
} from 'util/constants';
import { bindActionCreatorsForm } from 'util/safeDispatch';
import { getActivePanelId } from 'state/selectors';
import LabeledField from 'view/Forms/LabeledField';
import CheckRadio from 'view/Forms/BulmaCheckRadio';
import { createMediaEngine } from 'state/commands/mediaEngineCommands';

type Props = {
  allActivationsUsed: boolean,
  createMediaEngine: typeof createMediaEngine,
  hideDialogPanel: typeof hideDialogPanel,
  intl: IntlShape,
} & FormProps;

class CreateMediaEngineDialog extends Component<Props> {
  isOkEnabled: Function;
  submit: Function;

  constructor() {
    super();

    this.isOkEnabled = this.isOkEnabled.bind(this);
    this.submit = this.submit.bind(this);
  }

  isOkEnabled() {
    return this.props.valid;
  }

  submit(data: Object, props: Props) {
    const me = {
      enabled: data.isActive,
      address: data.address,
      port: data.port,
      type: '',
    };
    this.props.createMediaEngine(me);
  }

  render() {
    const {
      activePanelId,
      allActivationsUsed,
      handleSubmit,
      intl: { formatMessage },
    } = this.props;
    return (
      <DialogPanel
        activePanelId={activePanelId}
        contentStyle={{ width: '600px', height: null }}
        customButtonText={formatMessage(localizedStrings.ADD)}
        dialogFocusId="address"
        hideDialogPanel={this.props.hideDialogPanel}
        isOkEnabled={this.isOkEnabled}
        onSave={handleSubmit(this.submit)}
        panelId={CREATE_MEDIA_ENGINE_PANEL_ID}
        panelTitle={formatMessage(localizedStrings.MEDIA_ENGINES_ACTION_ADD)}
        showCancel
      >
        <form className="portfolio-form-container">
          <LabeledField
            label={formatMessage(localizedStrings.MEDIA_ENGINES_COLUMN_ACTIVE)}
          >
            <Field
              component={CheckRadio}
              disabled={allActivationsUsed}
              id="isActive"
              name="isActive"
              type="checkbox"
            />
          </LabeledField>
          <LabeledField
            label={formatMessage(localizedStrings.MEDIA_ENGINES_COLUMN_ADDRESS)}
          >
            <Field
              className="input"
              component="input"
              id="address"
              name="address"
              type="text"
            />
          </LabeledField>
          <LabeledField
            label={formatMessage(localizedStrings.MEDIA_ENGINES_COLUMN_PORT)}
          >
            <Field
              className="input dir-svc-desc-form-field-small-width"
              component="input"
              id="port"
              max={65535}
              min={0}
              name="port"
              type="number"
            />
          </LabeledField>
        </form>
      </DialogPanel>
    );
  }
}

function validate(data: Object, props: Props) {
  const errors = {};
  if (!data.address) {
    errors.address = 'Required';
  }
  if (!data.port) {
    errors.port = 'Required';
  }
  return errors;
}

const form = reduxForm({ form: CREATE_MEDIA_ENGINE_PANEL_ID, validate })(
  CreateMediaEngineDialog
);

export default connect(
  state => ({
    activePanelId: getActivePanelId(state),
    initialValues: {
      port: MEDIA_ENGINE_DEFAULT_PORT,
    },
  }),
  (dispatch: Dispatch) =>
    bindActionCreatorsForm({ createMediaEngine, hideDialogPanel })
)(injectIntl(form));



// WEBPACK FOOTER //
// ./src/view/Pages/GlobalSettingsPages/CreateMediaEngineDialog.js